angular.module('qkr').factory('userManagementService', ($http, appConfig) => ({
		
		getContext(level) {
			return $http.get(appConfig.apiUrl + 'userManagement/getContext/' + level).then((response) => response.data);
		},

        loadUserList() {
            return $http.get(appConfig.apiUrl + 'userManagement/list').then((response) => response.data);
        },

        loadRoleList() {
        	return $http.get(appConfig.apiUrl + 'userManagement/getSubordinateRoles').then((response) => response.data);
        },

        createUserPost(form) {
        	const createUserCommand = this.convertFormToUserCommand(form);
        	return $http.post(appConfig.apiUrl + 'userManagement/createUser', createUserCommand).then((response) => response, (response) => response);
        },

        updateUserPost(form) {
            const updateUserCommand = this.convertFormToUserCommand(form);

            return $http.post(appConfig.apiUrl + 'userManagement/updateUser', updateUserCommand).then((response) => response, (response) => response);
        },

        deleteUser(userId) {
             return $http.post(appConfig.apiUrl + 'userManagement/deleteUser', {id: userId}).then((response) => response.data);
        },

        updateDisplayBrowserAlert(commandBrowser) {
            return $http.post(appConfig.apiUrl + 'userManagement/updateDisplayBrowserAlert', commandBrowser).then((response) => response.data);
        },

        getUserById(userId) {
            return $http.get(appConfig.apiUrl + 'userManagement/get', {id: userId}).then((response) => response.data);
        },

        getWebUserBySessionId(userId) {
            return $http.get(appConfig.apiUrl + 'userManagement/getWebUserBySessionId/' + userId).then((response) => response.data);
        },

        sendActivateEmail(userId) {
            return $http.post(appConfig.apiUrl + 'userManagement/sendActivateEmail', {id: userId}).then((response) => response.data);
        },

        convertFormToUserCommand(form) {
            const ret = {
                username: form.username,
                originalName: form.originalName,
                firstName: form.firstName,
                lastName: form.lastName,
                webUserRoleList: [{field: form.role.rolename}],
                partner: this.getPartner(form.partner),
                initialPassword: form.password,
                openApiConsumerKey: form.openApiConsumerKey
            };
            if (form.outlet) {
                ret.merchantLoc = {id: form.outlet.id};
            }
            if (form.merchant) {
                ret.merchant = {id: form.merchant.id};
            }
            return ret;
        },

        getPartner(partner) {
            if (partner && partner.allowedBusinessCategories) {
                partner.allowedBusinessCategories = partner.allowedBusinessCategories.join(",");
            }
            return partner;
        }
    }));



// WEBPACK FOOTER //
// ./src/services/userManagement.services.js